<template>
  <roe-error-message :field="design.employer_match_hire_date">
    <datepicker
      v-model="design.$model.employer_match_hire_date"
      :disabled-dates="disableDates"
      :clear-button="true"
    ></datepicker>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import Datepicker from "vuejs-datepicker";
export default {
  name: "RoeEmployerMatchHireDateInput",
  components: { Datepicker, RoeErrorMessage },
  props: {
    design: Object
  },
  computed: {
    disableDates() {
      return {
        from: new Date()
      };
    }
  }
};
</script>
